import type { ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Button } from "./Button";
import { Skeleton } from "./Skeleton";
import { StatePanel } from "./StatePanel";

export function RoutePendingState() {
  const { t } = useTranslation("foundation");
  return (
    <section
      aria-busy="true"
      aria-label={t("routeStates.loadingLabel")}
      className="route-state route-state--pending"
    >
      <Skeleton className="route-skeleton__label" />
      <Skeleton className="route-skeleton__title" />
      <Skeleton className="route-skeleton__copy" />
      <Skeleton className="route-skeleton__copy route-skeleton__copy--short" />
      <div className="route-skeleton__body">
        <Skeleton shape="media" />
        <div>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    </section>
  );
}

export function RouteErrorState({ reset }: ErrorComponentProps) {
  const { t } = useTranslation("foundation");
  return (
    <div className="route-state route-state--error">
      <StatePanel
        action={<Button onClick={reset}>{t("common.tryAgain")}</Button>}
        description={t("routeStates.errorDescription")}
        headingLevel={1}
        state="error"
        title={t("routeStates.errorTitle")}
      />
    </div>
  );
}
